import React from 'react';
import { Scale } from 'lucide-react';
import { toast } from 'sonner';
import { compareStore, useCompareIds, COMPARE_MAX } from '../services/compareStore';
import { useT } from '../services/i18n';

// Checkbox toggling a product in the comparison list (same subcategory, max 3)
const CompareButton = ({ product }) => {
  const { t } = useT();
  const ids = useCompareIds();
  const active = ids.includes(String(product.id));
  const onChange = () => {
    const r = compareStore.toggle(product);
    if (r.removed) toast.success(t('cmp.removed'));
    else if (r.ok) toast.success(t('cmp.added', { n: compareStore.ids().length, max: COMPARE_MAX }), { action: { label: t('cmp.open'), onClick: () => { window.location.href = '/comparaison'; } } });
    else if (r.reason === 'max') toast.error(t('cmp.maxReached', { max: COMPARE_MAX }));
    else toast.error(t('cmp.sameSub'));
  };
  return (
    <label data-testid={`compare-toggle-${product.id}`} onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1.5 text-xs font-medium cursor-pointer select-none px-2 py-1 rounded-md border transition-colors ${active ? 'text-[#1e3a5f] bg-blue-50 border-blue-200' : 'text-gray-500 border-gray-200 hover:border-[#1e3a5f] hover:text-[#1e3a5f]'}`}>
      <input type="checkbox" checked={active} onChange={onChange} data-testid={`compare-checkbox-${product.id}`} className="h-3.5 w-3.5 accent-[#1e3a5f] cursor-pointer" />
      <Scale size={12} /> {active ? t('cmp.checked') : t('cmp.check')}
    </label>
  );
};

export default CompareButton;
